<template>

  <Form
    :title="$t('Application notifications')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(careersite)">
      <h5 class="mb-4">{{ $t('Notifications') }}</h5>

      <div class="form-group mb-4">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="gdpr"
            v-model="careersite.apply_confirm_job_enabled">
          <label
            class="form-check-label"
            for="gdpr">
            Personalizar mensagem de confirmação de candidatura na vaga
            </label>
        </div>
        <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_enabled']" />
        <div v-if="careersite.apply_confirm_job_enabled">
          <div class="mb-3">
            <input 
              type="text" 
              class="form-control mb-1" 
              v-model="careersite.apply_confirm_job_subject" 
              :placeholder="$t('Subject')">
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_subject']" />
          </div>
          <div>
            <textarea-editable
              v-model="careersite.apply_confirm_job_body"
              :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]']"
              editor-model="html"
              :enable-link="true"
              :enable-img="true">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_job_body']" />
          </div>
        </div>
      </div>

      <div class="form-group mb-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="gdpr"
            v-model="careersite.apply_confirm_enabled">
          <label
            class="form-check-label"
            for="gdpr">
            Personalizar mensagem de confirmação de candidatura na base
            </label>
        </div>
        <ValidateMessage :error="validateErrors['careersite.apply_confirm_enabled']" />
        <div v-if="careersite.apply_confirm_enabled">
          <div class="mb-3">
            <input 
              type="text" 
              class="form-control mb-1" 
              v-model="careersite.apply_confirm_subject" 
              :placeholder="$t('Subject')">
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_subject']" />
          </div>
          <div>
            <textarea-editable
              v-model="careersite.apply_confirm_body"
              :variables="['[candidate_full_name]', '[candidate_first_name]']"
              editor-model="html"
              :enable-link="true"
              :enable-img="true">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['careersite.apply_confirm_body']" />
          </div>
        </div>
      </div>

    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'AccountCareersite',
  components: {
    Form
  },
  data () {
    return {
      creating: true,
      loading: false,
      careersite: {},
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountCareersite', this.account._id)
      .then(result => {
        this.careersite = result.careersite
        this.creating = false
      })
    },
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountCareersite', {
        _id: this.account._id,
        careersite: data
      })
      .then(result => {
        this.careersite = result.careersite
        this.loading = false
        this.validateErrors = {}
      })
      .catch(err => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountCareersite.vue